import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDuplicateSectionMutation = createMutationHook(
  ShopRendererDraftApiClient.duplicateSection,
  {
    mutationKey: ['duplicateSection'],
  },
)
